import { httpV1 as http } from '../api';

const ALT_API_URL = `${process.env.VUE_APP_ALT_BASE_API_URL || process.env.VUE_APP_BASE_API_URL}/v1`;

export async function list(params) {
  return http.get('/qitech/fgts/balance-wait-list', { params });
}

export async function consult(params) {
  return http.get('/private-payroll/balance', { params });
}

export async function consultTduBank(params) {
  return http.get('/private-payroll/tdubank/balance', { params });
}

export async function riskAnalysisTduBank(data) {
  return http.post(`${ALT_API_URL}/private-payroll/tdubank/risk-analysis`, data);
}

export async function etapaUmSimuladorTduBank(data) {
  return http.post(`${ALT_API_URL}/private-payroll/tdubank/etapa-um-simulador`, data);
}

export async function etapaDoisSimuladorTduBank(data) {
  return http.post(`${ALT_API_URL}/private-payroll/tdubank/etapa-dois-simulador`, data);
}

export async function etapaTresSimuladorTduBank(data) {
  return http.post(`${ALT_API_URL}/private-payroll/tdubank/etapa-tres-simulador`, data);
}

export async function simulate(data) {
  return http.post('/private-payroll/simulation', data);
}

export async function simulateTduBank(data) {
  return http.post('/private-payroll/tdubank/simulation', data);
}

export async function riskCompany(params) {
  return http.get('/risk/companies/info', { params });
}

export async function riskPeople(params) {
  return http.get('/risk/people/info', { params });
}

export async function approve(data) {
  return http.post(`${ALT_API_URL}/private-payroll/approve`, data);
}

export async function creditOperation(data) {
  return http.post(`${ALT_API_URL}/private-payroll/credit-operation`, data);
}

export async function serasaCompany(params) {
  return http.get(`${ALT_API_URL}/risk/companies/serasa-check`, { params });
}

export async function serasaPeople(params) {
  return http.get(`${ALT_API_URL}/risk/people/serasa-check`, { params });
}

export async function employeeRelationship(params) {
  return http.get('/private-payroll/employment-relationships-inquiry', { params });
}

export async function employeeRelationshipTduBank(params) {
  return http.get('/private-payroll/tdubank/employment-relationships-inquiry', { params });
}

export async function proposal(params) {
  return http.get('/private-payroll/proposal', { params });
}

export async function authorizeReservation(data) {
  return http.post(`${ALT_API_URL}/private-payroll/authorize-reservation`, data);
}

export async function cancelReservation(data) {
  return http.post(`${ALT_API_URL}/private-payroll/cancel`, data);
}

export async function updateDisbursement(data) {
  return http.put('/private-payroll/update-disbursement-date', data);
}

export async function reSimulate(data) {
  return http.post('/private-payroll/resimulate', data);
}

export async function renegotiate(data) {
  return http.post('/private-payroll/renegotiate', data);
}

export async function simulationRenegotiation(data) {
  return http.post('/private-payroll/simulate/renegotiation', data);
}

export async function cancelRenegotiation(data) {
  return http.delete('/private-payroll/cancel-renegotiation', { data });
}

export async function reversal(data) {
  return http.post('/private-payroll/reversal', data);
}

export async function riskCheckCompany(data) {
  return http.post(`${ALT_API_URL}/risk/check-company-dispatching`, data);
}

export async function getContracts(params) {
  const { data } = await http.get('/private-payroll/contracts', { params });
  return data;
}

export async function getContractByProposalId(proposal_id) {
  const { data } = await http.get(`/private-payroll/contracts/${proposal_id}`);
  return data;
}

export async function getCommunicationsByProposalId(params) {
  const { data } = await http.get('/private-payroll/employer-communications', { params });
  return data;
}

export async function getCommunicationById(id) {
  const { data } = await http.get(`/private-payroll/employer-communications/${id}`);
  return data;
}

export async function getCommunicationHistory({ id, ...params }) {
  const { data } = await http.get(`/private-payroll/employer-communications/${id}/history`, { params });
  return data;
}

export async function registerActivitie({ communication_id, ...data }) {
  return http.post(`/private-payroll/employer-communications/${communication_id}/history`, data);
}

export async function saveNote({ id, ...data }) {
  return http.put(`/private-payroll/employer-communications/history/${id}/notes`, data);
}

export async function getEmailTemplates(params) {
  const { data } = await http.get('/private-payroll/email-templates', { params });
  return data;
}

export async function createCommunication(data) {
  return http.post('/private-payroll/employer-communications/manual', data);
}

export async function changeCommunicationStatus({ id, ...data }) {
  return http.put(`/private-payroll/employer-communications/${id}/status`, data);
}

export async function getChannels(params) {
  const { data } = await http.get('/private-payroll/channels', { params });
  return data;
}

export async function getCompaniesWithWrittenContracts(params) {
  return http.get('/private-payroll/companies-with-written-contracts', { params });
}

export async function getCompaniesContracts(params) {
  return http.get('/private-payroll/contracts', { params });
}

export async function receipt(params) {
  return http.get('/private-payroll/reservation', { params });
}
